module.exports = __webpack_public_path__ + "img/2.713f267a.jpg";